import Image from "next/image";
import type { ComponentPropsWithoutRef } from "react";

import { useCICOModal } from "../ci-co-date-selection-modal";
import { useAccommodationFilterContext } from "../filters/accommodation-filter-context";

type CalendarEmptyStateProps = {
  showSearchDates?: boolean;
};

function PillButton({
  onClick,
  children,
  ...props
}: ComponentPropsWithoutRef<"button"> & {
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      {...props}
      type="button"
      onClick={onClick}
      className="border-skogecha-40 bg-swhite font-notojp text-skogecha-100 rounded-full border px-[24px] py-[12px] text-[14px] font-bold"
    >
      {children}
    </button>
  );
}

export function CalendarEmptyState({
  showSearchDates,
}: CalendarEmptyStateProps) {
  const { open: openCICOModal } = useCICOModal();
  const { hasAnyActiveFilter, openFilterModal } =
    useAccommodationFilterContext();

  return (
    <div className="border-skogecha-16 bg-swhite flex flex-col items-center border-b py-[48px]">
      <div className="flex flex-col items-center gap-[24px]">
        <Image src="/i/calendar-x.svg" width={90} height={90} alt="" />
        <div className="flex flex-col items-center gap-[16px]">
          <p className="font-notojp text-skogecha-100 text-[16px] leading-[1.6] font-bold">
            この条件で利用できる部屋がありません
          </p>
          <p className="font-notojp text-skogecha-60 text-center text-[12px] leading-[1.6]">
            別の空き状況をチェックして、自然の中へ出かけませんか？
          </p>
        </div>
        <div className="flex gap-[12px]">
          {showSearchDates && (
            <PillButton
              data-analytics-id="reservation_calendar_opened_date_picker_empty"
              onClick={openCICOModal}
            >
              別の日程で探す
            </PillButton>
          )}
          {hasAnyActiveFilter && (
            <PillButton
              data-analytics-id="reservation_calendar_opened_filters_empty"
              onClick={openFilterModal}
            >
              条件を変更する
            </PillButton>
          )}
        </div>
      </div>
    </div>
  );
}
